import { useRef } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { isEmpty, sortBy } from 'lodash';
import { FormattedMessage, IntlProvider } from 'react-intl';
import Card from "../../Card/Card";
import CardHeader from "../../Card/CardHeader";
import CardText from "../../Card/CardText";
import Divider from "../../Divider/Divider";
import MoreOrLessButton from "../../MoreOrLessButton/MoreOrLessButton";
import Addresses from "../../../utils/Addresses";
import Providers from "../../../utils/Providers";
import Locations from "../../Location/Locations/Locations";
import ProviderDescription from "../components/ProviderDescription/ProviderDescription";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProviderDetails = props => {
  const {
    center = {
      lat: 0,
      lng: 0
    },
    className = '',
    clickableAddress = false,
    initiallyCollapsed = false,
    openLink = typeof window !== 'undefined' ? window.open : () => {},
    provider = {},
    providerLocations = [],
    showMore,
    title = 'About',
    intlProvider = {
      locale: 'en',
      messages: []
    }
  } = props;
  const originLatLng = [center.lat, center.lng];
  const calculatedDistances = providerLocations.map(address => Addresses.calculateDistance(address, originLatLng));
  const locationsByDistance = sortBy(calculatedDistances, add => add.distanceVal) || [];
  const isInNetworkGroup = Providers.isInNetworkGroup(provider);
  const titleText = !isEmpty(intlProvider) ? /*#__PURE__*/_jsx(FormattedMessage, {
    id: "LKNMNm",
    description: "about-header",
    defaultMessage: "About",
    children: txt => /*#__PURE__*/_jsx("div", {
      children: txt
    })
  }) : title;
  const containerRef = useRef(null);
  const handleMoreOrLessToggle = () => {
    if (containerRef.current) {
      containerRef.current.focus();
    }
  };
  return /*#__PURE__*/_jsx(IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages,
    children: /*#__PURE__*/_jsx(Card, {
      className: cn('rounded border-light-border-blue', className),
      children: /*#__PURE__*/_jsxs("div", {
        ref: containerRef,
        tabIndex: "-1",
        children: [/*#__PURE__*/_jsx(CardHeader, {
          className: "text-lg text-text-blue border-b border-solid border-light-border-blue",
          title: titleText
        }), /*#__PURE__*/_jsx(CardText, {
          className: "bg-none max-h-full",
          containerStyle: {
            padding: '0px'
          },
          children: initiallyCollapsed ? /*#__PURE__*/_jsxs(MoreOrLessButton, {
            onClick: handleMoreOrLessToggle,
            children: [/*#__PURE__*/_jsx(ProviderDescription, {
              className: "provider-details__section p-5",
              provider: provider,
              isInNetworkGroup: isInNetworkGroup,
              openLink: openLink,
              intlProvider: intlProvider
            }), !isEmpty(providerLocations) && /*#__PURE__*/_jsx(Divider, {
              className: "border-b border-light-border-blue"
            }), /*#__PURE__*/_jsx(Locations, {
              className: "provider-details__section px-5 pt-5",
              clickableAddress: clickableAddress,
              isInNetworkGroup: isInNetworkGroup,
              locations: locationsByDistance,
              showMore: showMore,
              intlProvider: intlProvider
            })]
          }) : /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(ProviderDescription, {
              className: "provider-details__section p-5",
              provider: provider,
              isInNetworkGroup: isInNetworkGroup,
              openLink: openLink,
              showMore: true,
              intlProvider: intlProvider
            }), !isEmpty(providerLocations) && /*#__PURE__*/_jsx(Divider, {
              className: "border-b border-light-border-blue"
            }), /*#__PURE__*/_jsx(Locations, {
              className: "provider-details__section px-5 pt-5",
              clickableAddress: clickableAddress,
              isInNetworkGroup: isInNetworkGroup,
              locations: locationsByDistance,
              showMore: true,
              intlProvider: intlProvider
            })]
          })
        })]
      })
    })
  });
};
ProviderDetails.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  provider: PropTypes.object,
  initiallyCollapsed: PropTypes.bool,
  openLink: PropTypes.func,
  providerLocations: PropTypes.array,
  showMore: PropTypes.bool.isRequired,
  title: PropTypes.string,
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.array
  })
};
export default ProviderDetails;
//# sourceMappingURL=ProviderDetails.js.map